<template>
    <vx-card id="loader">
        <div class="vx-row">
            <div class="vx-col w-1/2">
                <h3>Коэффициенты сайтов (Push)</h3>
            </div>
        </div>

        <div class="vx-row mt-5">
            <div class="vx-col w-1/2">
                <h3>Фильтры</h3>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col w-1/4 mb-1">
                <label class="vs-input--label"> Интервал </label>
                <date-picker
                    v-model="form.dateTime"
                    type="datetime"
                    format="YYYY-MM-DD-HH:mm:ss"
                    placeholder="Интервал времени события"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>

            <div class="vx-col w-1/5">
                <label class="vs-input--label"> SSP </label>
                <v-select :options="dicts.sspTypes" label="name" placeholder="Выберите SSP" class="w-full" v-model="form.sspTypeId" :reduce="(a) => a.id">
                </v-select>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input
                    v-model="form.siteId"
                    autocomplete="off"
                    label="ID площадки"
                    placeholder="Введите ID площадки..."
                    class="mt-1 w-full"/>
            </div>
        </div>

        <div class="vx-row mt-1">
            <div class="vx-col">
                <vs-button class="mt-1" color="warning" @click="loadData()" type="filled"> Применить </vs-button>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <vs-table :sst="true" :data="coeffs" class="mt-5" search>
                    <template slot="thead">
                        <vs-th sort-key="sspId"> SSP </vs-th>
                        <vs-th sort-key="sspId"> Группа SSP </vs-th>
                        <vs-th sort-key="deviceTypeName"> ID площадки </vs-th>
                        <vs-th sort-key="siteCoeff"> Коэффициент </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ tr.sspName }}
                            </vs-td>
                            <vs-td>
                                {{ tr.sspGroupName }}
                            </vs-td>
                            <vs-td>
                                {{ tr.siteId }}
                            </vs-td>
                            <vs-td>
                                {{ tr.siteCoeffCpm | formatNumber(2) }}
                            </vs-td>
                            <template slot="expand">
                                <ul>
                                    <li>Расход SSP по сайту (buyout_sum)={{ tr.buyoutsSum }}</li>
                                    <li>Расход DSP по сайту (click_sum)={{ tr.clicksSum }}</li>
                                    <li>Расход SSP по группе (all_buyout_sum)={{ tr.buyoutsAllSum }}</li>
                                    <li>Расход DSP по группе (all_click_sum)={{ tr.clicksAllSum }}</li>
                                    <li>Коэф. сайта (site_coeff_cpm)=(click_sum({{ tr.clicksSum }})/buyout_sum({{ tr.buyoutsSum }})) / (all_click_sum({{ tr.clicksAllSum }})/all_buyout_sum({{ tr.buyoutsAllSum }}))={{ tr.siteCoeffCpm }} ({{ tr.siteCoeffCpmCustomData }} в КХ)</li>
                                </ul>
                            </template>
                        </vs-tr>
                    </template>
                </vs-table>

                <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
            </div>
        </div>
    </vx-card>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';

export default {
    name: 'blockCpmCoefficients',
    data() {
        return {
            page: 1,
            pagesTotal: 1,
            pageSize: 25,

            coeffs: [],
            form: {
                dateTime: undefined,
                sspTypeId: undefined,
                siteId: undefined,
                statusId: undefined,
                campaignId: undefined,
                buyoutsLimit: 20000,
                clicksLimit: 50,
                onlyUniqLessThan: undefined,
                orderBy: undefined,
                isAscOrder: undefined
            },
            dicts: {
                sspTypes: []
            }
        };
    },

    components: {
        vSelect,
        DatePicker
    },

    methods: {
        loadData(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            const params = {
                dateTime: this.form.dateTime,
                sspId: this.form.sspTypeId,
                siteId: this.form.siteId,
                orderBy: this.form.orderBy,
                isAscOrder: this.form.isAscOrder,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('site-coeff-push', { params: params }),
                    this.axios.get('site-coeff-push/count', { params: params }),
                    this.axios.get('site-coeff-push/dicts'),
                ])
                .then(
                    axios.spread((coeffs, count, dicts) => {
                        this.coeffs = coeffs.data;
                        this.dicts = dicts.data;
                        this.pagesTotal = Math.floor(count.data / this.pageSize) + 1;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadDicts(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            this.axios
                .all([
                    this.axios.get('site-coeff-push/dicts'),
                ])
                .then(
                    axios.spread((dicts) => {
                        this.dicts = dicts.data;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        handleSort(key, active) {
            this.form.orderBy = key;
            this.form.isAscOrder = active == 'asc';

            this.loadData();
        },
        setDefaultValues() {
            // let endDay = this.$moment(new Date());
            // let endDayStr = endDay.format('YYYY-MM-DD ');
            // let startDay = endDay.add(-1, 'days');
            // let startDayStr = startDay.format('YYYY-MM-DD ');
            // let startTime = '00:00:00';
            // let endTime = '23:59:59';
            // this.dateInterval = [startDayStr + startTime, endDayStr + endTime];
            this.form.dateTime = this.$moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        },
    },

    watch: {
        page: function () {
            this.loadData();
        }
    },

    mounted() {
        this.loadDicts();
        this.setDefaultValues();
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}
thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.header-title {
    flex-direction: column;
}

.content-tr-expand {
    display: block;
}
.vs-pagination--mb {
    justify-content: center !important;
}
</style>
